const CART_STORAGE_KEY = 'plukk_shop_cart_v1';

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const getStorageKey = (scopeKey) => {
  const key = String(scopeKey || 'global');
  // Backward compatible default cart key so existing users keep their cart.
  if (!key || key === 'global') return CART_STORAGE_KEY;
  return `${CART_STORAGE_KEY}:${key}`;
};

export const loadCart = (scopeKey = 'global') => {
  if (!isBrowser()) return {};
  try {
    const raw = window.localStorage.getItem(getStorageKey(scopeKey));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
};

export const saveCart = (cart, scopeKey = 'global') => {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(getStorageKey(scopeKey), JSON.stringify(cart || {}));
  } catch (e) {
    // ignore
  }
};

export const addToCart = (productId, qty = 1, scopeKey = 'global') => {
  if (!productId) return loadCart(scopeKey);
  const cart = loadCart(scopeKey);
  const nextQty = Math.max(1, Number(cart[productId] || 0) + Number(qty || 0));
  const next = { ...cart, [productId]: nextQty };
  saveCart(next, scopeKey);
  return next;
};

export const setCartQty = (productId, qty, scopeKey = 'global') => {
  if (!productId) return loadCart(scopeKey);
  const cart = loadCart(scopeKey);
  const next = { ...cart };
  const nextQty = Number(qty || 0);
  if (nextQty <= 0) {
    delete next[productId];
  } else {
    next[productId] = nextQty;
  }
  saveCart(next, scopeKey);
  return next;
};

export const removeFromCart = (productId, scopeKey = 'global') => setCartQty(productId, 0, scopeKey);

export const clearCart = (scopeKey = 'global') => {
  saveCart({}, scopeKey);
  return {};
};
